import {
  CREATE_USER_ERROR,
  CREATE_USER_SUCCESS,
  FETCH_USERS_SUCCESS,
  SET_ADMIN_REDUCER,
  TESTING_ERROR,
  TESTING_SUCCESS,
  UPDATE_USER_ERROR,
  UPDATE_USER_SUCCESS,
} from "../types/adminTypes";
import {
  FORBIDDEN_ACTION,
  LOGOUT_SUCCESS,
  UNAUTHORIZED_USER,
} from "../types/authTypes";

const initState = {
  users: [],
  updateUserSuccess: false,
  updateUserError: false,
  testResult: null,

  createUserSuccess: false,
  createUserError: false,
};

const adminReducer = (state = initState, action) => {
  switch (action.type) {
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload?.rows,
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        updateUserSuccess: true,
        updateUserError: false,
      };
    case UPDATE_USER_ERROR:
      return {
        ...state,
        updateUserSuccess: false,
        updateUserError: true,
      };
    case TESTING_SUCCESS:
      return {
        ...state,
        testResult: action.payload,
      };
    case TESTING_ERROR:
      return {
        ...state,
        testResult: null,
      };
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        createUserSuccess: true,
        createUserError: false,
        createUserMsg: action?.message,
      };
    case CREATE_USER_ERROR:
      return {
        ...state,
        createUserSuccess: false,
        createUserError: true,
        createUserMsg: action?.message,
      };

    case LOGOUT_SUCCESS:
    case UNAUTHORIZED_USER:
    case FORBIDDEN_ACTION:
      return initState;

    case SET_ADMIN_REDUCER:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default adminReducer;
